import React from 'react';

import { ACADEMY_MODULE_TYPES } from 'data/academyModuleTypes';
import generateModuleTypeSelectOption from '@moduleManagement/utils/generateModuleTypeSelectOption';
import Select from 'components/Select';

const SELECT_OPTIONS = Object.values(ACADEMY_MODULE_TYPES).map((moduleType) =>
  generateModuleTypeSelectOption(moduleType)
);

export default function AcademyModuleTypeSelect(props) {
  return (
    <Select
      {...props}
      placeholder="Select Academy Module Type"
      options={SELECT_OPTIONS}
    />
  );
}
